import React from 'react'
import { Stack } from '@thirstycamel/ui'
import ReactMarkdown from 'react-markdown'
import './IndexSeoContent.css'

interface IndexSeoContentProps {
  content?: string
}

export const IndexSeoContent = ({ content }: IndexSeoContentProps) => {
  if (!content) {
    return null
  }

  return (
    <Stack
      className="index-seo-content"
      maxW="1350px"
      mx="auto"
      p={4}
      pb={12}
      fontSize={['xs', 'sm', 'md']}
    >
      {/* Homepage SEO copy is pulled from db_config_entity using the INDEX_SEO_COPY key. */}
      <ReactMarkdown>{content}</ReactMarkdown>
    </Stack>
  )
}

export default IndexSeoContent
